import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './bootstrap';
import App from './App';
import BaseProviders from './context/BaseProviders';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

try {
  const container = document.getElementById('root');

  if (!container) throw new Error('Container does not exist');
  const root = createRoot(container);

  const queryClient = new QueryClient();

  root.render(
    // <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BaseProviders>
        <App />
      </BaseProviders>
      <ReactQueryDevtools
        initialIsOpen={false}
        buttonPosition='bottom-right'
        position='right'
      />
    </QueryClientProvider>,
    // </StrictMode>,
  );
} catch (err) {
  console.error(err);
}
